//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmSpisovyPlan.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Spisov� pl�n </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.15.2
//AdtGeneratorConfig:[ T:(sslsspl) GID:(Web.Dia.Ts) V1:(spis_pl,lic,aktivita,arw,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,nazev,popis,priz_vycet,oddelovace,prirustek,priz_num,priz_manual,priz_check_lev,root_level,priz_end_znak,ixs_tre,spis_pl_ext) V2:() K1:() K2:() ]

namespace Gordic.Adm.Dialogs {

    // AdmSpisovyPlan
    export function DetailAdmSpisovyPlanDlg(
        parentContent: GContent,
        opt: {
            /** spis_pl */
            spis_pl: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmSpisovyPlan', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmSpisovyPlan#",
        spis_pl: opt ? opt.spis_pl : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmSpisovyPlan
    export function SeznamAdmSpisovyPlanDlg(
        parentContent: GContent,
        opt: {
            /** spis_pl */
            spis_pl: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmSpisovyPlan', { }]

    const options = {
        ID: "AdmAdmSpisovyPlan#",
        spis_pl: opt ? opt.spis_pl : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
